import { createAction, props } from '@ngrx/store';

export const changeRenewal = createAction(
  '[RenewalPreference] Change Renewal',
  props<{ renewalPreference: string }>()
);

export type RenewalPreferenceActionsUnion = ReturnType<typeof changeRenewal>;
